import styled from 'styled-components';

import Heading from 'components/Heading';

export const Wrapper = styled.div`
  margin-top: ${props => props.theme.spacing.medium};
  position: relative;
`;

export const HeadingStyled = styled(Heading)`
  margin-bottom: ${props => props.theme.spacing.default};
`;
